import { isImageDocument, isLargeImageFileName } from './media';

type DocumentLike = {
  fileName?: string | null;
  url?: string | null;
  isPrimary: boolean;
  isDeleted: boolean;
};

function pickFromDocs(docs: DocumentLike[] | undefined): string | null {
  if (!docs?.length) return null;
  const nonDeleted = docs.filter((d) => !d.isDeleted && isImageDocument(d));
  if (!nonDeleted.length) return null;

  // Prefer `{prefix}_L.*` when present so lightbox/catalogue opens the large
  // image even if a video (or thumbnail) owns isPrimary (BLS-339).
  const large = nonDeleted.filter((d) => isLargeImageFileName(d.fileName));
  const pool = large.length > 0 ? large : nonDeleted;
  const primary = pool.find((d) => d.isPrimary);
  const chosen = primary ?? pool[0];
  return chosen?.url ?? null;
}

/**
 * Picks the display image URL for lot-animal rows.
 * 1. Prefer documents: non-deleted images; prefer `_L` large files, then
 *    isPrimary, else first. Return url if any.
 * 2. Fallback to animalDocuments: same logic.
 * 3. Otherwise return null (no image).
 */
export function pickPrimaryImageUrl(
  documents?: DocumentLike[],
  animalDocuments?: DocumentLike[],
): string | null {
  const fromDocs = pickFromDocs(documents);
  if (fromDocs) return fromDocs;
  return pickFromDocs(animalDocuments);
}
